// src/components/customer/modal/Modal.jsx
import React, { useEffect } from "react";
import { X } from "lucide-react";
import "../../../assets/css/customer/modal/Modal.css";

const Modal = ({ isOpen, onClose, title, children, size = "medium" }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="custmodal-backdrop" onClick={handleBackdropClick}>
      <div className={`custmodal-container custmodal-${size}`}>
        {/* Header */}
        {title ? (
          <div className="custmodal-header">
            <h2 className="custmodal-title">{title}</h2>
            <button
              className="custmodal-close-btn"
              onClick={onClose}
              aria-label="Close modal"
            >
              <X size={18} />
            </button>
          </div>
        ) : (
          <button
            className="custmodal-close-btn custmodal-close-absolute"
            onClick={onClose}
            aria-label="Close modal"
          >
            <X size={18} />
          </button>
        )}

        {/* Content */}
        <div className="custmodal-content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
